import React, { memo, useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  sidebarSetStateValue,
  sidebarTypeSet,
} from "../../../redux/actions/sidebarActions";
import { loanDrilldownSidebarTypes } from "../../../constants/enums/loanDrilldownScreenSidebarOptions";
import { Button } from "@mui/material";
import { AddCardOutlined } from "@mui/icons-material";

const LoanDrilldownButtonSidebarAdd = memo(
  ({
    size = "small",
    type,
    children,
    icon = <AddCardOutlined className="thin" />,
    sx,
  }) => {
    const dispatch = useDispatch();

    const onAdd = useCallback(() => {
      dispatch(sidebarTypeSet(type));
      dispatch(sidebarSetStateValue(null));
    }, [dispatch, type]);

    return (
      <Button sx={sx} size={size} startIcon={icon} onClick={onAdd}>
        {children || "Add Item"}
      </Button>
    );
  }
);
export default LoanDrilldownButtonSidebarAdd;
